import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const FormularioSubNews = ({ subnewsSeleccionada, onGuardar, onCancelar }) => {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    image: null,
  });

  useEffect(() => {
    if (subnewsSeleccionada) {
      setFormData({
        title: subnewsSeleccionada.title,
        content: subnewsSeleccionada.content,
        image: subnewsSeleccionada.image,
      });
    }
  }, [subnewsSeleccionada]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onGuardar(formData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="title">
        <Form.Label>title</Form.Label>
        <Form.Control
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />
      </Form.Group>
      <Form.Group controlId="content">
        <Form.Label>Content</Form.Label>
        <Form.Control
          as="textarea"
          name="content"
          value={formData.content}
          onChange={handleChange}
          rows={5}
          required
        />
      </Form.Group>
      <Form.Group controlId="image">
        <Form.Label>Imagen</Form.Label>
        <Form.Control
          type="file"
          name="image"
          onChange={handleChange}
        />
      </Form.Group>
      <div className="mt-3">
        <Button variant="primary" type="submit">Guardar</Button>{' '}
        <Button variant="secondary" onClick={onCancelar}>Cancelar</Button>
      </div>
    </Form>
  );
};

export default FormularioSubNews;
